
import React, { useRef } from "react";
import { ReactFlowProvider } from '@xyflow/react';
import { FlowChart } from "./FlowChart";
import { CustomNode } from "./CustomNode";

const nodeTypes = {
  custom: CustomNode
};

type OrganizationChartProps = {
  nodes: any[];
  edges: any[];
  onNodesChange: any;
  onEdgesChange: any;
  onEdgesDelete: any;
  onConnect: any;
  onNodeClick: any;
};

export const OrganizationChart = ({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onEdgesDelete,
  onConnect,
  onNodeClick
}: OrganizationChartProps) => {
  const reactFlowWrapperRef = useRef(null);

  return (
    <div 
      style={{ height: '500px' }} 
      ref={reactFlowWrapperRef} 
      className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple p-4 px-[6px] py-[6px] h-[530px]"
    >
      <h3 className="text-lg font-semibold mb-4 text-white">Organization Chart</h3>
      <div style={{ height: 'calc(100% - 40px)' }}>
        <ReactFlowProvider>
          <FlowChart 
            nodes={nodes} 
            edges={edges} 
            onNodesChange={onNodesChange} 
            onEdgesChange={onEdgesChange} 
            onEdgesDelete={onEdgesDelete} 
            onConnect={onConnect} 
            nodeTypes={nodeTypes} 
            onNodeClick={onNodeClick}
          />
        </ReactFlowProvider>
      </div>
    </div>
  );
};
